module.exports = __webpack_public_path__ + "static/media/icon_menu_home.cae58f4f.svg";